import { render } from "./OtherSubsidiesFinal.vue?vue&type=template&id=71646a67"
import script from "./OtherSubsidiesFinal.vue?vue&type=script&lang=js"
export * from "./OtherSubsidiesFinal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__